<template>
  <!-- System message or regular message bubble -->
  <div v-if="isSystemMessage" class="system-message">
    <span class="system-message-text">{{ messageData.msg }}</span>
  </div>
  <div v-else class="message-bubble relative">
    <div :class="bubbleContentClass">
      {{ messageData.msg }}
    </div>
    <div :class="arrowClass">
      <img :src="arrowIcon" alt="Arrow" class="w-[18px] h-[18px]"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Message',
  props: {
    messageData: {
      type: Object,
      required: true
    },
    rc_user_id: {
      type: String,
      required: true
    }
  },
  computed: {
    isSystemMessage() {
      const userId = this.messageData.u?._id;

      return userId === 'oafKicny6TymdzNxQ' || userId === 'EuMKAsjDZTsLc74Kw';
    },

    isCurrentUser() {
      return !this.isSystemMessage && this.messageData.u._id === this.rc_user_id;
    },

    bubbleContentClass() {
      return this.isCurrentUser ? 'bubble-content user-bubble mr-2' : 'bubble-content not-user-bubble';
    },

    arrowClass() {
      return this.isCurrentUser ? 'absolute top-[8px] right-[2px]' : 'absolute top-[8px] left-[2px]';
    },

    arrowIcon() {
      return this.isCurrentUser
        ? require('@/assets/MyPatient/message_arrow1.svg')
        : require('@/assets/MyPatient/message_arrow2.svg');
    }
  }
}
</script>

<style scoped>
.message-bubble {
  position: relative;
  word-wrap: break-word;
}

.bubble-content {
  padding: 12px 24px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  position: relative;
  color: #000000;
}

/* User message bubble styling */
.user-bubble {
  background-color: #e4f3f5;
  border-radius: 20px 20px 20px 20px;
  margin-right: 14px;
}

/* Not user message bubble styling */
.not-user-bubble {
  background-color: #f2f2f2;
  margin-left: 14px;
  color: #333333;
  border-radius: 20px 20px 20px 20px;
}

/* System message styling */
.system-message {
  display: flex;
  align-items: center;
  font-family: 'Intel', sans-serif;
  font-size: 13px;
  line-height: 18px;
  font-weight: 500;
  color: #666666;
  max-width: 100%;
}

.system-message-indicator {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  background-color: #e8e8e8;
  color: #666666;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 3px;
  flex-shrink: 0;
}

.system-message-text {
  color: #666666;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .bubble-content {
    font-size: 14px;
    line-height: 20px;
    padding: 10px 14px;
  }

  .system-message {
    font-size: 12px;
    padding: 6px 10px;
  }

  .system-message-indicator {
    font-size: 10px;
    padding: 2px 6px;
  }
}
</style>
